import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { useI18n } from '../locales';
import { SiteRouterLink } from 'apps/site/src/app/components/RouterLink';

const useStyles = makeStyles()({
	root: {
		position: 'absolute',
		background: 
		'white',
		top: 0,
		left: 0,
		bottom: 0,
		right: 0,
		zIndex: 2
	}
})

export function AuthSetupPasswordFormSuccess() {
	const { classes } = useStyles();
	const { t, Trans } = useI18n();
	return (
		<Box sx={{
			position: 'absolute',
			background: 'white',
			top: 0,
			left: 0,
			bottom: 0,
			right: 0,
			zIndex: 2,
			textAlign: 'center',
			boxSizing: 'border-box',
			pb: 1
		}}>
			<Typography
				display='block'
				fontSize={14}
				mb={2}
				textAlign='center'
			>
				{t('Password successfully changed')}.{' '}
				<div>
					<Trans
						i18nKey="Use new password to <0>Sign in account</0>"
						components={[
							<SiteRouterLink
								to='/auth/login'
								underline='hover'
								color='primary'
								fontSize='inherit'
								whiteSpace='nowrap'
								display='inline'
							/>
						]}
					/>.
				</div>
			</Typography>
		</Box>
	);
}
